import _ from 'lodash';

export function partial<T extends object, R>(obj: T, propKeys?: [keyof T]) {
  const keys = (propKeys ?? Object.keys(obj)) as [keyof T];
  const result = {};
  keys.forEach((key) => {
    const value = _.get(obj, key);
    if (typeof value !== 'function' && typeof value !== 'function') {
      _.set(result, key, value);
    }
  });

  return result as R;
}

export function getFileName(path?: string) {
  if (!path) {
    return path;
  }

  return path.split('/').pop();
}
